import { Component, h, Prop, Listen, Element, State } from "@stencil/core";
import {
  validProductPrice,
  setInstallmentsByPrice,
  sendEvent,
  validMoClientId,
  removeMoIframe,
  createMoIframe,
  convertToBase64,
} from "../../utils/utils";
import { environment } from "../../global/resources";
import { OFFERS_MOCK } from "../../global/data-mock";

@Component({
  tag: "mo-product-page",
  styleUrl: "mo-product-page.css",
  shadow: true,
})
export class MoProductPage {
  @Element() el: HTMLElement;
  @Prop() moClientId!: string;
  @Prop() productPrice?: string;
  @Prop() offerType: string = "3";
  amountReference: number = 5000;
  public urlBase: string = environment.base_url;
  public apiUrl: string = environment.api_url;
  @State() minimumValue: string | undefined = undefined;
  @State() errorGetPreviewOffer: boolean = false;
  @State() offersAvailable: boolean = false;
  @Listen("closeIframe", { target: "document" })
  closeIframeHandlerEvent(event: CustomEvent) {
    if (!!event) this.removeIframe();
  }

  componentDidLoad() {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 1.0,
    };
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          sendEvent("product", "view");
          observer.unobserve(entry.target);
        }
      });
    }, options);

    if (Number(this.productPrice) <= this.amountReference) {
      if (this.apiUrl) {
        this.getOffersByMerchant();
      } else {
        this.fetchMockData();
      }
    }
    observer.observe(this.el);
  }

  async getOffersByMerchant() {
    try {
      const clientKey = convertToBase64(this.moClientId);
      const response = await fetch(
        `${this.apiUrl}/app/offers?amount=${this.productPrice}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: clientKey,
          },
        }
      );
      const data = await response.json();
      this.offersAvailable = data.length !== 0;
      const offer = this.getOffer(data);
      this.getPreviewOffer(offer);
      // Procesa los datos como necesites
    } catch (error) {
      console.error("Error al llamar a la API:", error);
    }
  }
  async getPreviewOffer(offer: any) {
    const offerId = offer?.id;
    const numberInstallments = offer?.repayment_frequency?.minimum_installments;
    try {
      const clientKey = convertToBase64(this.moClientId);

      const response = await fetch(
        `${this.apiUrl}/app/offers/${offerId}/preview?amount=${this.productPrice}&number_of_installments=${numberInstallments}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: clientKey,
          },
        }
      );
      const data = await response.json();
      this._setMinimumValue(data);
      // Procesa los datos como necesites
    } catch (error) {
      console.error("Error al llamar a la API:", error);
      this.errorGetPreviewOffer = true;
    }
  }
  async fetchMockData() {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(OFFERS_MOCK);
      }, 1000);
    })
      .then((data: any[]) => {
        const offer = this.getOffer(data);
      })
      .catch((error) => {
        console.error("Error con los datos mockeados:", error);
      });
  }

  private getOffer(data: any[]) {
    const result = data.sort(
      (a, b) =>
        b.repayment_frequency.minimum_installments -
        a.repayment_frequency.minimum_installments
    );
    return result[0];
  }

  private _setMinimumValue = (offer: any) => {
    const minimumValue = offer.installments[0].amount;
    const numberWithFormat = Number(minimumValue).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    const symbol = "S/";
    this.minimumValue = `${symbol} ${numberWithFormat}`;
  };
  private addIframe = (
    clientId: string,
    price: string,
    gtagCategory: string
  ) => {
    sendEvent(gtagCategory, "click");
    return !!validMoClientId(clientId)
      ? createMoIframe(clientId, price)
      : console.warn("Invalid MO Client ID");
  };
  private removeIframe = () => removeMoIframe();

  render() {
    return (
      <div class="mo-product-page">
        {Number(this.productPrice) <= this.amountReference ? (
          <div class="mo-product-page__text">
            {this.minimumValue ? (
              <p>
                Desde <b>{this.minimumValue} al mes</b> o en 3 cuotas sin
                intereses
              </p>
            ) : (
              this.errorGetPreviewOffer && !this.offersAvailable ? (
                <p class="mo-product-page__text-large">
              ¡Con Powerpay, elige<br class="mobile" /> cómo pagar <b>hasta<br /> S/ 5,000!</b>
            </p>
              ) : ( <div class="skeleton-loader"></div> )
            )}

            <p>
              Con <b>todas las tarjetas de crédito</b>
              <a
                href="javascript:void()"
                onClick={() =>
                  this.addIframe(this.moClientId, this.productPrice, "product")
                }
              >
                <b>Más información</b>
              </a>
            </p>
          </div>
        ) : (
          <div class="mo-product-page__text">
            <p class="mo-product-page__text-large">
              ¡Con Powerpay, elige<br class="mobile" /> cómo pagar <b>hasta<br /> S/ 5,000!</b>
            </p>
            <p>
              Con <b>todas las tarjetas de <br class="mobile" /> 
              crédito.</b>
              <a
                href="javascript:void()"
                onClick={() =>
                  this.addIframe(this.moClientId, this.productPrice, "product")
                }
              >
                <b>Más información</b>
              </a>
            </p>
          </div>
        )}
        <div class="mo-product-page__image">
          <svg
            viewBox="0 0 110 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.81891 4.56951L6.01765 8.33892H8.15778C9.32508 8.33892 10.2391 7.58488 10.482 6.44194C10.7197 5.32335 10.1262 4.56951 8.95886 4.56951H6.81891ZM14.7378 6.44194C14.0295 9.77354 10.8842 11.9865 7.35801 11.9865H5.2424L4.18267 16.9718H0L3.41148 0.921875H9.70994C13.236 0.921875 15.4614 3.03747 14.7378 6.44194Z"
              fill="#9930E2"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M18.7531 10.8922C18.4326 12.3999 19.164 13.4212 20.5744 13.4212C21.8877 13.4212 23.126 12.3999 23.4465 10.8922C23.7618 9.40887 22.9627 8.36315 21.6495 8.36315C20.2392 8.36315 19.0684 9.40887 18.7531 10.8922ZM27.7265 10.8922C26.9563 14.5157 23.3811 17.2635 19.7333 17.2635C16.0613 17.2635 13.7029 14.5157 14.4732 10.8922C15.2433 7.26892 18.7699 4.52087 22.4419 4.52087C26.0897 4.52087 28.4966 7.26892 27.7265 10.8922Z"
              fill="#9930E2"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M49.5179 9.62768H53.7492C53.9383 8.50909 53.1886 7.80377 52.1185 7.80377C51.0971 7.80377 50.1064 8.46039 49.5179 9.62768ZM56.8666 12.3514H49.0849C49.3454 13.2997 50.2007 13.7375 51.5139 13.7375C52.6812 13.7375 53.7749 13.3971 54.9012 12.789L55.8041 15.6343C54.1125 16.7285 52.3938 17.2635 50.6186 17.2635C46.606 17.2635 44.3692 14.5157 45.1394 10.8922C45.9095 7.26892 49.3389 4.52087 52.9865 4.52087C56.5856 4.52087 58.2301 7.19586 57.5736 10.2843C57.4185 11.0138 57.1262 11.8163 56.8666 12.3514Z"
              fill="#9930E2"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M68.4395 4.81281L67.6538 8.50915H66.6568C64.8087 8.50915 63.5925 9.3117 63.1427 11.4273L61.9642 16.9719H57.7815L60.3661 4.81281H64.1838L63.9098 6.10169C64.8653 5.1532 66.049 4.61816 67.2894 4.61816C67.7514 4.61816 68.125 4.69123 68.4395 4.81281Z"
              fill="#9930E2"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M77.2886 10.8922C77.6504 9.18987 76.6936 8.31444 75.4532 8.31444C74.2861 8.31444 72.929 9.09264 72.5517 10.8678C72.1796 12.6189 73.1659 13.47 74.3575 13.47C75.5733 13.47 76.9268 12.5945 77.2886 10.8922ZM81.5736 10.8678C80.7829 14.5885 77.7825 17.2635 74.378 17.2635C73.0648 17.2635 72.107 16.8501 71.503 16.1449L70.3968 21.349H66.2141L69.7291 4.81274H73.5468L73.278 6.07727C74.249 5.05591 75.5302 4.52087 77.0866 4.52087C80.491 4.52087 82.3646 7.14715 81.5736 10.8678Z"
              fill="#073382"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M89.539 12.5215L89.5596 12.4242H87.59C86.8847 12.4242 86.3989 12.7646 86.2749 13.3484C86.1508 13.9319 86.5109 14.2967 87.3134 14.2967C88.3592 14.2967 89.3012 13.6401 89.539 12.5215ZM94.2748 9.91937L92.7758 16.9717H88.9578L89.1698 15.9747C88.1481 16.7772 86.8531 17.2635 85.394 17.2635C82.6461 17.2635 81.5834 15.5125 82.0124 13.4941C82.4983 11.2082 84.6309 9.87084 87.549 9.87084H90.1024L90.1438 9.6762C90.3299 8.80077 89.9395 8.1198 88.6263 8.1198C87.4592 8.1198 86.5135 8.67919 85.2713 9.60332L83.8892 6.95269C85.8111 5.34759 87.6405 4.52087 89.9021 4.52087C93.2093 4.52087 95.0399 6.32025 94.2748 9.91937Z"
              fill="#073382"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M110 4.81274L101.561 17.6285C99.7661 20.352 97.9359 21.6408 95.4069 21.6408C94.6285 21.6408 93.8033 21.5193 93.1343 21.349L93.8785 17.8473C94.4571 17.8714 94.8896 17.8958 95.2787 17.8958C96.2515 17.8958 97.1146 17.7257 97.9669 16.4612L98.2492 16.0477L96.1871 4.81274H100.637L101.519 11.646L105.574 4.81274H110Z"
              fill="#073382"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M33.4612 4.63672H27.8828L31.8478 14.3747L34.6818 8.87326L33.4612 4.63672Z"
              fill="#9930E2"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M44.0062 1.35767L38.5518 9.51342L38.0474 4.93704L29.4592 21.8579L35.9627 14.8339L36.8986 18.0716L49.7197 1.35767H44.0062Z"
              fill="#9930E2"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M93.9113 25.3936L92.067 28.9044C92.0269 28.9804 91.9134 28.9804 91.8732 28.9046L90.0275 25.3934C90.0089 25.3586 89.9726 25.3364 89.9329 25.3364H89.0409C88.9803 25.3364 88.9416 25.401 88.9704 25.4545L91.876 30.893C91.9162 30.9681 92.0241 30.9681 92.0644 30.893L94.9702 25.4547C94.9988 25.4012 94.96 25.3366 94.8995 25.3366H94.0058C93.9661 25.3366 93.9298 25.3586 93.9113 25.3936Z"
              fill="#073382"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M94.9581 30.0786L96.8023 26.5678C96.8425 26.4918 96.9561 26.4918 96.9962 26.5676L98.8419 30.0787C98.8605 30.1138 98.8968 30.1358 98.9365 30.1358H99.8285C99.889 30.1358 99.9276 30.0712 99.899 30.0177L96.9934 24.5791C96.9532 24.5041 96.8453 24.5041 96.805 24.5791L93.8992 30.0175C93.8706 30.071 93.9094 30.1356 93.9701 30.1356H94.8636C94.9033 30.1356 94.9396 30.1136 94.9581 30.0786Z"
              fill="#073382"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M81.1625 30.1355L79.4999 30.1357C79.4408 30.1357 79.393 30.0878 79.393 30.0287L79.3928 28.5378C79.3928 28.479 79.4408 28.431 79.4997 28.431H81.1625C81.9549 28.431 82.309 28.6557 82.309 29.2834C82.309 29.911 81.9627 30.1355 81.1625 30.1355ZM79.5008 26.1481H81.1404C81.7448 26.1481 82.0525 26.4067 82.0525 26.8831C82.0525 27.3617 81.7459 27.6181 81.1404 27.6181H79.5008C79.4418 27.6181 79.3939 27.5703 79.3939 27.5113V26.2551C79.3939 26.196 79.4418 26.1481 79.5008 26.1481ZM82.3553 27.9266C82.7401 27.734 82.9807 27.3172 82.9807 26.804C82.9807 25.9298 82.2992 25.3367 81.3371 25.3367H78.5724C78.5134 25.3367 78.4656 25.3845 78.4656 25.4433V30.8423C78.4656 30.9014 78.5134 30.9495 78.5724 30.9495H81.2158C82.5387 30.9495 83.2364 30.38 83.2364 29.2655C83.2364 28.1775 82.3553 27.9266 82.3553 27.9266Z"
              fill="#073382"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M86.8334 30.1355L85.1707 30.1357C85.1117 30.1357 85.0639 30.0878 85.0639 30.0287V28.5378C85.0639 28.479 85.1117 28.431 85.1707 28.431H86.8334C87.6258 28.431 87.9799 28.6557 87.9799 29.2834C87.9799 29.911 87.6336 30.1355 86.8334 30.1355ZM85.1717 26.1481H86.8113C87.4157 26.1481 87.7232 26.4067 87.7232 26.8831C87.7232 27.3617 87.4168 27.6181 86.8113 27.6181H85.1717C85.1126 27.6181 85.0648 27.5703 85.0648 27.5113V26.2551C85.0648 26.196 85.1126 26.1481 85.1717 26.1481ZM88.0262 27.9266C88.411 27.734 88.6516 27.3172 88.6516 26.804C88.6516 25.9298 87.9701 25.3367 87.0079 25.3367H84.2433C84.1843 25.3367 84.1365 25.3845 84.1365 25.4433V30.8423C84.1365 30.9014 84.1843 30.9495 84.2433 30.9495H86.8865C88.2096 30.9495 88.9073 30.38 88.9073 29.2655C88.9073 28.1775 88.0262 27.9266 88.0262 27.9266Z"
              fill="#073382"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10.5491 30.0877V27.8035H10.9616V30.0039C10.9616 30.4463 11.147 30.6617 11.5894 30.6617C11.9902 30.6617 12.3309 30.4463 12.6898 30.1117V27.8035H13.1023V30.9487H12.7315L12.6898 30.4524C12.3728 30.7574 11.9721 31.0144 11.4937 31.0144C10.866 31.0144 10.5491 30.6737 10.5491 30.0877Z"
              fill="#073382"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M14.0532 30.9489V27.8036H14.4239L14.4657 28.3001C14.7766 27.989 15.1773 27.7379 15.6557 27.7379C16.2895 27.7379 16.6064 28.0787 16.6064 28.6646V30.9489H16.1939V28.7484C16.1939 28.306 16.0024 28.0848 15.56 28.0848C15.1593 28.0848 14.8185 28.294 14.4657 28.6347V30.9489H14.0532Z"
              fill="#073382"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M19.4701 30.1655V29.1851C18.0828 29.424 17.7421 29.753 17.7421 30.1596C17.7421 30.4885 17.9574 30.6618 18.316 30.6618C18.7586 30.6618 19.1472 30.4766 19.4701 30.1655ZM17.3354 30.2076C17.3354 29.5854 17.8675 29.1371 19.4701 28.8921V28.7305C19.4701 28.3001 19.2368 28.0848 18.8243 28.0848C18.3341 28.0848 17.9932 28.282 17.6583 28.5811L17.4251 28.3241C17.8019 27.9772 18.2144 27.7379 18.8542 27.7379C19.5538 27.7379 19.8767 28.1147 19.8767 28.7425V30.9489H19.5121L19.4701 30.5003C19.1053 30.8232 18.6987 31.0027 18.2264 31.0027C17.6644 31.0027 17.3354 30.6978 17.3354 30.2076Z"
              fill="#073382"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M21.9697 29.3764C21.9697 28.2462 22.6693 27.7379 23.3748 27.7379C23.949 27.7379 24.3194 28.049 24.5347 28.4855L24.2119 28.6827C24.0325 28.3001 23.7934 28.0848 23.3628 28.0848C22.8964 28.0848 22.3822 28.4375 22.3822 29.3764C22.3822 30.1836 22.8009 30.6679 23.3569 30.6679C23.7813 30.6679 24.0265 30.4586 24.2359 30.052L24.5408 30.2493C24.2777 30.7516 23.8951 31.0147 23.333 31.0147C22.6095 31.0147 21.9697 30.4229 21.9697 29.3764Z"
              fill="#073382"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M27.5306 29.3764C27.5306 28.6827 27.1837 28.0907 26.5199 28.0907C25.8803 28.0907 25.5035 28.6347 25.5035 29.3764C25.5035 30.076 25.8443 30.662 26.5199 30.662C27.1538 30.662 27.5306 30.1179 27.5306 29.3764ZM25.0908 29.3764C25.0908 28.3241 25.7428 27.7379 26.5199 27.7379C27.2913 27.7379 27.9431 28.3241 27.9431 29.3764C27.9431 30.4229 27.2913 31.0147 26.5199 31.0147C25.7487 31.0147 25.0908 30.4229 25.0908 29.3764Z"
              fill="#073382"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M28.7205 30.9489V27.8036H29.0911L29.133 28.3001C29.4439 27.989 29.8147 27.7379 30.287 27.7379C30.8193 27.7379 31.0702 27.9711 31.16 28.306C31.4829 27.9949 31.8775 27.7379 32.3439 27.7379C32.9898 27.7379 33.2528 28.1027 33.2528 28.6707V30.9489H32.8402V28.7484C32.8402 28.306 32.6908 28.0907 32.2482 28.0907C31.8655 28.0907 31.5486 28.3001 31.1958 28.6408V30.9489H30.7833V28.7484C30.7833 28.306 30.6339 28.0907 30.1853 28.0907C29.8086 28.0907 29.4857 28.3001 29.133 28.6408V30.9489H28.7205Z"
              fill="#073382"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M36.5294 29.3764C36.5294 28.5095 36.099 28.0907 35.5726 28.0907C35.1841 28.0907 34.9092 28.2883 34.5922 28.6048V30.1478C34.9151 30.4766 35.2081 30.6561 35.5848 30.6561C36.1108 30.6561 36.5294 30.2793 36.5294 29.3764ZM34.1797 32.1746V27.8038H34.5502L34.5922 28.2462C34.8433 27.9713 35.1723 27.7379 35.6446 27.7379C36.368 27.7379 36.9419 28.2702 36.9419 29.3703C36.9419 30.4706 36.3621 31.0027 35.6326 31.0027C35.2022 31.0027 34.8732 30.8055 34.5922 30.5182V32.115L34.1797 32.1746Z"
              fill="#073382"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M39.6087 30.1655V29.1851C38.2215 29.424 37.8807 29.753 37.8807 30.1596C37.8807 30.4885 38.0961 30.6618 38.4547 30.6618C38.8973 30.6618 39.2859 30.4766 39.6087 30.1655ZM37.4741 30.2076C37.4741 29.5854 38.0062 29.1371 39.6087 28.8921V28.7305C39.6087 28.3001 39.3755 28.0848 38.963 28.0848C38.4728 28.0848 38.1318 28.282 37.797 28.5811L37.5638 28.3241C37.9405 27.9772 38.3531 27.7379 38.9929 27.7379C39.6925 27.7379 40.0153 28.1147 40.0153 28.7425V30.9489H39.6508L39.6087 30.5003C39.244 30.8232 38.8373 31.0027 38.365 31.0027C37.8031 31.0027 37.4741 30.6978 37.4741 30.2076Z"
              fill="#073382"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M41.7971 27.146C41.6237 27.146 41.5519 27.2418 41.5578 27.4929L41.2947 27.4449C41.2947 27.0204 41.4681 26.8112 41.7971 26.8112C42.1318 26.8112 42.4369 27.146 42.6821 27.146C42.8553 27.146 42.9271 27.0503 42.9271 26.7992L43.1843 26.847C43.1843 27.2717 43.0109 27.4807 42.6821 27.4807C42.3471 27.4807 42.0421 27.146 41.7971 27.146ZM40.936 30.9488V27.8036H41.3067L41.3486 28.3001C41.6594 27.989 42.0602 27.7379 42.5386 27.7379C43.1723 27.7379 43.4893 28.0788 43.4893 28.6646V30.9488H43.0767V28.7486C43.0767 28.306 42.8852 28.0848 42.4428 28.0848C42.0421 28.0848 41.7013 28.2941 41.3486 28.6347V30.9488H40.936Z"
              fill="#073382"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M45.1157 26.53H45.6598L44.8169 27.463H44.5477L45.1157 26.53ZM44.446 30.9489H44.8586V27.8036H44.446V30.9489Z"
              fill="#073382"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M47.7884 30.1655V29.1851C46.4012 29.424 46.0604 29.753 46.0604 30.1596C46.0604 30.4885 46.2757 30.6618 46.6344 30.6618C47.077 30.6618 47.4655 30.4766 47.7884 30.1655ZM45.6538 30.2076C45.6538 29.5854 46.1859 29.1371 47.7884 28.8921V28.7305C47.7884 28.3001 47.5552 28.0848 47.1427 28.0848C46.6525 28.0848 46.3115 28.282 45.9767 28.5811L45.7435 28.3241C46.1202 27.9772 46.5327 27.7379 47.1726 27.7379C47.8722 27.7379 48.195 28.1147 48.195 28.7425V30.9489H47.8305L47.7884 30.5003C47.4237 30.8232 47.017 31.0027 46.5447 31.0027C45.9828 31.0027 45.6538 30.6978 45.6538 30.2076Z"
              fill="#073382"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M52.6438 30.1355V28.5988C52.3208 28.2701 52.0278 28.0847 51.6511 28.0847C51.131 28.0847 50.7065 28.4854 50.7065 29.3763C50.7065 30.2433 51.1369 30.6499 51.6633 30.6499C52.0518 30.6499 52.3269 30.4586 52.6438 30.1355ZM50.2939 29.3822C50.2939 28.2819 50.8738 27.7378 51.6033 27.7378C52.0337 27.7378 52.4046 27.9531 52.6438 28.2341V26.5539L53.0562 26.4941V30.9487H52.6857L52.6438 30.4943C52.3928 30.7694 52.0636 31.0026 51.5915 31.0026C50.8679 31.0026 50.2939 30.4824 50.2939 29.3822Z"
              fill="#073382"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M56.0999 29.131C56.0578 28.533 55.7709 28.0845 55.209 28.0845C54.7546 28.0845 54.3239 28.4255 54.2522 29.131H56.0999ZM53.8337 29.3701C53.8337 28.2581 54.5511 27.7377 55.2149 27.7377C55.9444 27.7377 56.5004 28.2998 56.5004 29.3762V29.4538H54.2463C54.2522 30.2252 54.6948 30.6676 55.2807 30.6676C55.6992 30.6676 55.9982 30.5062 56.2912 30.2014L56.4945 30.4704C56.1477 30.835 55.8008 31.0145 55.2746 31.0145C54.4795 31.0145 53.8337 30.4464 53.8337 29.3701Z"
              fill="#073382"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M57.3135 30.9488V26.554L57.726 26.494V30.9488H57.3135Z"
              fill="#073382"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M59.9382 28.7184C59.9382 27.3312 60.7157 26.4403 61.7859 26.4403C62.5034 26.4403 63.0296 26.8051 63.3047 27.4748L62.928 27.6541C62.7187 27.11 62.3719 26.829 61.7859 26.829C61.0146 26.829 60.3629 27.4689 60.3629 28.7005C60.3629 29.9263 60.9428 30.6499 61.7918 30.6499C62.5333 30.6499 63.0237 30.1177 63.0176 29.2326H61.9773L61.9114 28.8681H63.4303V30.9488H63.0477V30.309H63.0355C62.8324 30.7036 62.4319 31.0326 61.756 31.0326C60.602 31.0326 59.9382 30.04 59.9382 28.7184Z"
              fill="#073382"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M64.3872 30.9489V27.8036H64.7579L64.7997 28.4196H64.8117C65.051 28.037 65.4337 27.7379 66.0495 27.7379H66.0912L66.1272 28.1206C66.1152 28.1146 65.9897 28.1147 65.9777 28.1147C65.4575 28.1147 65.0388 28.4015 64.7997 28.898V30.9489H64.3872Z"
              fill="#073382"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M66.7134 30.0877V27.8035H67.1259V30.0039C67.1259 30.4463 67.3113 30.6617 67.7537 30.6617C68.1545 30.6617 68.4952 30.4463 68.8541 30.1117V27.8035H69.2666V30.9487H68.8958L68.8541 30.4524C68.5371 30.7574 68.1364 31.0144 67.658 31.0144C67.0303 31.0144 66.7134 30.6737 66.7134 30.0877Z"
              fill="#073382"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M72.567 29.3764C72.567 28.5095 72.1366 28.0907 71.6102 28.0907C71.2217 28.0907 70.9468 28.2883 70.6298 28.6048V30.1478C70.9527 30.4766 71.2457 30.6561 71.6224 30.6561C72.1484 30.6561 72.567 30.2793 72.567 29.3764ZM70.2173 32.1746V27.8038H70.5877L70.6298 28.2462C70.8809 27.9713 71.2099 27.7379 71.6822 27.7379C72.4056 27.7379 72.9795 28.2702 72.9795 29.3703C72.9795 30.4706 72.3997 31.0027 71.6702 31.0027C71.2398 31.0027 70.9108 30.8055 70.6298 30.5182V32.115L70.2173 32.1746Z"
              fill="#073382"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M76.0233 29.3764C76.0233 28.6827 75.6765 28.0907 75.0126 28.0907C74.373 28.0907 73.9965 28.6347 73.9965 29.3764C73.9965 30.076 74.337 30.662 75.0126 30.662C75.6466 30.662 76.0233 30.1179 76.0233 29.3764ZM73.5837 29.3764C73.5837 28.3241 74.2356 27.7379 75.0126 27.7379C75.7842 27.7379 76.4358 28.3241 76.4358 29.3764C76.4358 30.4229 75.7842 31.0147 75.0126 31.0147C74.2415 31.0147 73.5837 30.4229 73.5837 29.3764Z"
              fill="#073382"
            />
          </svg>
        </div>
        {/* <div class='mo-product-page__button'>
          <mo-button
            price={this.productPrice}
            buttonType='product'
            clientId={this.moClientId}
            offerByPrice={validProductPrice(this.productPrice)}
            gtagCategory='product'
          ></mo-button>
        </div> */}
      </div>
    );
  }
}

export interface IProduct {
  offerType: string;
  productValue: string;
}
